
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class AttendanceDetailsGrid extends Serenity.EntityGrid<AttendanceDetailsRow, any> {
        protected getColumnsKey() { return 'HR.AttendanceDetails'; }
        protected getDialogType() { return AttendanceDetailsDialog; }
        protected getIdProperty() { return AttendanceDetailsRow.idProperty; }
        protected getInsertPermission() { return AttendanceDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return AttendanceDetailsRow.localTextPrefix; }
        protected getService() { return AttendanceDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}